import styled from 'styled-components'
import { tokens } from 'styling/tokens'
import { IFieldInput } from 'types/ui/field.interface'

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.space.xs};
`

export const FieldLabel = styled.label`
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
`

export const FieldControl = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`

export const FieldInput = styled.input<IFieldInput>`
  width: 100%;
  height: 2.5rem;
  padding: 0 ${tokens.space.sm};
  ${(props) => props.$hasRight && 'padding-right: 3.5rem;'}
  background: ${tokens.surface.inset};
  border: 1px solid ${(props) => (props.$hasError ? tokens.status.danger.fg : tokens.border.hairline)};
  border-radius: ${tokens.radius.control};
  color: ${tokens.text.primary};
  font-size: ${tokens.font.body};

  &::placeholder {
    color: ${tokens.text.muted};
  }
  &:focus-visible {
    outline: 2px solid ${(props) => (props.$hasError ? tokens.status.danger.fg : tokens.accent.base)};
    outline-offset: 2px;
  }
  &:read-only {
    opacity: 0.7;
    cursor: default;
  }
`

export const FieldRight = styled.div`
  position: absolute;
  right: ${tokens.space.sm};
  display: flex;
  align-items: center;
  color: ${tokens.text.muted};
  pointer-events: none;
`

export const FieldToggle = styled.button`
  position: absolute;
  right: ${tokens.space.sm};
  background: none;
  border: none;
  padding: 0;
  color: ${tokens.accent.onDark};
  font-size: ${tokens.font.label};
  font-weight: 500;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${tokens.accent.base};
    outline-offset: 2px;
  }
`

export const FieldHint = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const FieldError = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.status.danger.fg};
`
